<template>
  <div class="filter-types-container-mobile">
    <FilterTypeMobile
      v-for="filterType in filterTypes"
      :key="filterType.id"
      :filter-type="filterType"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FilterTypeMobile from './FilterTypeMobile.vue'

export default {
  name: 'FilterTypesContainerMobile',

  components: {
    FilterTypeMobile
  },

  computed: {
    ...mapGetters({
      filterTypes: 'listingPageFilters/typeFilters',
      filterParams: 'listingPageFilters/filterParams'
    })
  }
}
</script>
